@import "@/scss/use-bootstrap-mixins.scss";

.wrapper {
  margin-bottom: 30px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  gap: 12px;
  padding: 16px;

  @include media-breakpoint-up(lg) {
    gap: 24px;
    flex-direction: row;
    padding: 0px;
  }

  .label {
    font-size: 18px;
    font-weight: 500;
    color: #000;

    @include media-breakpoint-up(lg) {
      display: revert;
      font-size: 24px;
    }
  }

  .options {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;

    @include media-breakpoint-up(lg) {
      gap: 24px;
    }

    button {
      cursor: pointer;
      border: none;
      background: transparent;
      font-size: 16px;
      font-weight: 400;
      padding: 8px 16px;
      border-radius: 100px;
    }

    .active {
      background: $primary;
      color: $textColorOnPrimary;
    }

    .inactive {
      background: #fff;
      color: #434343;

      @include media-breakpoint-up(lg) {
        background: #f5f5f5;
      }
    }

    .active:focus-visible,
    .inactive:focus-visible {
      outline: 2px solid $primary;
      outline-offset: 2px;
    }
  }
}
